var map = {
	"./Albon.jpg": "4gfN",
	"./Alonso.jpg": "OZIZ",
	"./Bottas.jpg": "DRQi",
	"./DeVries.jpg": "4rGx",
	"./Gasly.jpg": "HV5S",
	"./Guanyu.jpg": "PQQO",
	"./Hamilton.jpg": "CDfV",
	"./Hulk.jpg": "Q3gL",
	"./Leclerc.jpg": "gfUQ",
	"./Magnussen.jpg": "C1aM",
	"./Norris.jpg": "FoQI",
	"./Ocon.jpg": "+qA/",
	"./Perez.jpg": "vNlY",
	"./Piastri.jpg": "Pp+g",
	"./Russell.jpg": "6xZp",
	"./Sainz.jpg": "3LlP",
	"./Sargeant.jpg": "feLg",
	"./Stroll.jpg": "Atx/",
	"./Tsunoda.jpg": "DwJu",
	"./Verstappen.jpg": "HZ9V"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "53WL";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.jpg$
// module id = 53WL
// module chunks = 1